<div class="operation-table">
  <div class="operation-table-header">
    <ng-content select="[slot='header']"></ng-content>
  </div>
  <div class="operation-table-body">
    <ng-content select="[slot='body']"></ng-content>
  </div>
</div>
